import React from 'react';
import useIsMobile from '@/hooks/useIsMobile';
import useEditor from './useEditor';
import Desktop from './desktop';
import Mobile from './mobile';

const ProductEditorPage = () => {
  const isMobile = useIsMobile(992);
  const viewModel = useEditor();

  return isMobile ? <Mobile viewModel={viewModel} /> : <Desktop viewModel={viewModel} />;
};

export default ProductEditorPage;